import { TableColumn } from "react-data-table-component";
import { IConfig, IUserNotification } from "src/services/types";
import './style.css';

export const columnsUsersWhomNotification: (
    config: IConfig, 
) => TableColumn<IUserNotification>[] = 
(config) => {
    return (
[
    { 
      name: "N°",
      center: true,
      width: "70px",
      selector: (_, index, ) => (config.page-1)*config.per_page + (index! + 1),
    },
    {
        name: "USER",
        width: "200px",
        cell: function OrderItems(item) {
          return (
            <div className="">
              <p className="m-0">{item?.full_name}</p>
              <small className="text-muted">{item?.email}</small>
            </div>
          );
        }
    },
    {
      name: "STATUS",
      width: "80px",
      center: true,
      cell: function OrderItems(item) {
        return (
          <>
            <span className={"px-2 py-2 rounded-3 " + (item.send_status_description === 'Sent successfully.' ? 'bg-success-light' : 'bg-danger-light ')}>
                { item.send_status_description  === 'Sent successfully.' ? 'Success' : 'Failed' }
            </span>
          </>
        );
      }
    },
     {
      name: "STATUS DESCRIPTION",
      cell: function OrderItems(item) {
        return (
          <>
            <span className={"px-2 py-2 rounded-3 " + (item.send_status_description === 'Sent successfully.' ? 'text-success' : 'text-danger ')}>
                { item.send_status_description }
            </span>
          </>
        );
      }
    },
  ]
)}